import { Link, useNavigate } from "react-router";
import { Button } from "../ui/button";
import { ArrowLeft } from "lucide-react";

interface BreadcrumbProps {
  pageTitle: string;
  customBackAction?: () => void;
}

const PageBreadcrumb: React.FC<BreadcrumbProps> = ({ 
  pageTitle, 
  customBackAction 
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (customBackAction) {
      customBackAction();
    } else {
      navigate(-1); // Go back to previous page
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
      <div className="flex items-center gap-2">
          <Button 
            variant="outline" 
            size="sm"
            onClick={handleBackClick}
            className="flex items-center gap-1 h-7 px-2"
          >
            <ArrowLeft className="h-3 w-3" />
            Back
          </Button>
        <h2
          className="text-base font-semibold text-gray-800 dark:text-white/90"
          x-text="pageName"
        >
          {pageTitle}
        </h2>
      </div>
      <nav>
        <ol className="flex items-center gap-1 text-xs">
          <li>
            <Link
              className="inline-flex items-center gap-1 text-gray-500 dark:text-gray-400"
              to="/"
            >
              Home
              <svg
                className="stroke-current"
                width="12"
                height="12"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366"
                  stroke=""
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </li>
          <li className="text-gray-800 dark:text-white/90">
            {pageTitle}
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default PageBreadcrumb;
